<template>
  <NavigationLayout
    navigationTitle="口座情報"
    :navigationBarStyle="{
      'top': 'var(--safe-area-inset-top, 0px)',
    }"
    :navigationContentStyle="{
      'padding-top': 'calc(44px + var(--safe-area-inset-top, 0px))',
    }"
  >
    <div id="bank__wrapper" slot="contents">
      <div id="bank__container">
        <section>
          <div
            v-bind:style="VerifyResultsReasonsStyle"
            v-if="isVerifyResultExists"
          >
            <p
              v-for="(reason, index) in verifyResultReasons"
              :key="`verify_result_${index}`"
            >
              {{ reason }}
            </p>
          </div>

          <ListItem
            title="銀行名"
            v-bind:warning="verifyResultKeys.includes('bank_code')"
          >
            <input
              slot="actionInput"
              :value="depositBankAccount.bank_name"
              v-on:click="onClickBankNameInput"
              class="bank__input_bank_name"
              type="text"
              name="bank_name"
              placeholder="選択してください"
              readonly
              required
            />
          </ListItem>

          <ListItem
            title="口座種別"
            v-bind:warning="verifyResultKeys.includes('account_type')"
          >
            <select
              slot="actionInput"
              :value="depositBankAccount.account_type"
              @input="input($event, 'account_type')"
            >
              <option disabled value="" class="option_for_placeholder">
                選択してください
              </option>
              <option
                v-for="bankAccountType in BANK_ACCOUNT_TYPES"
                v-bind:value="bankAccountType.value"
                :key="bankAccountType.name"
              >
                {{ bankAccountType.name }}
              </option>
            </select>
          </ListItem>

          <ListItem
            title="支店コード"
            v-bind:warning="verifyResultKeys.includes('branch_code')"
          >
            <input
              slot="actionInput"
              :value="depositBankAccount.branch_code"
              @input="input($event, 'branch_code')"
              type="text"
              pattern="[0-9]*"
              name="branch_code"
              placeholder="例)123"
              required
            />
          </ListItem>
          <ListItem
            title="口座番号"
            v-bind:warning="verifyResultKeys.includes('account_number')"
            v-bind:style="ListItemStyleSectionLast"
          >
            <input
              slot="actionInput"
              :value="depositBankAccount.account_number"
              @input="input($event, 'account_number')"
              type="text"
              pattern="[0-9]*"
              name="account_number"
              placeholder="例)1234567"
              required
            />
          </ListItem>
        </section>
        <div>
          <div v-bind:style="CautionsStyle">
            <p>
              ＊ゆうちょ銀行の場合、支店コード欄に5桁の「記号」、口座番号欄に8桁以下の「番号」を入力してください。（振込用の「店番」「口座番号」ではありません）
            </p>
          </div>
        </div>
        <section>
          <ListItem
            title="口座名義（セイ）"
            v-bind:warning="verifyResultKeys.includes('account_name')"
          >
            <input
              slot="actionInput"
              :value="accountFamilyName"
              @input="input($event, 'account_family_name')"
              type="text"
              name="account_family_name"
              placeholder="例)ヤマダ"
              required
            />
          </ListItem>
          <ListItem
            title="口座名義（メイ）"
            v-bind:warning="verifyResultKeys.includes('account_name')"
            v-bind:style="ListItemStyleSectionLast"
          >
            <input
              slot="actionInput"
              :value="accountFirstName"
              @input="input($event, 'account_first_name')"
              type="text"
              name="account_first_name"
              placeholder="例)ハナコ"
              required
            />
          </ListItem>
        </section>
        <div>
          <div v-bind:style="CautionsStyle">
            <p>
              ＊振込先が存在しない場合、手数料として200LIVEポイントが引かれ、振込は発生しませんのでご注意ください。
            </p>
            <p>
              ＊誤った口座を登録した場合、組戻対応となるため、お問い合わせよりご連絡ください。組戻対応を行った場合、手数料として600LIVEポイント引かれます。
            </p>
            <p>
              ＊ご入力いただいたお客様の個人情報は、当社から配信者様への報酬のお支払いするために利用いたします。
            </p>
          </div>
        </div>
        <section id="personal__submit">
          <ButtonSubmit
            id="bank__submit_button"
            title="登録する"
            v-bind:disabled="!canSubmitInput"
            v-on:click.native="submit"
          />
        </section>
      </div>
      <BankPicker />
      <SubmitNotification
        v-bind:isActive="isSubmitNotificationActive"
        v-bind:onEntered="onSubmitNotificationEntered"
      />
    </div>
  </NavigationLayout>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import BankPicker from '@/components/BankPicker'
import NavigationLayout from '@/components/NavigationLayout'
import ListItem from '@/components/ListItem'
import SubmitNotification from '@/components/SubmitNotification'
import ButtonSubmit from '@/components/ButtonSubmit'
import MypageStyle from '@/styles/mypage'
import { BankAccountTypes } from '@/utils/MasterBank'
export default {
  components: {
    BankPicker,
    NavigationLayout,
    ListItem,
    SubmitNotification,
    ButtonSubmit,
  },
  data: function () {
    return {
      BANK_ACCOUNT_TYPES: BankAccountTypes,
      CautionsStyle: MypageStyle.Cautions,
      ListItemStyleSectionLast: MypageStyle.ListItemSectionLast,
      VerifyResultsReasonsStyle: MypageStyle.VerifyResultsReasons,
    }
  },
  computed: {
    ...mapState({
      depositBankAccount: (state) =>
        state.depositBankAccount.depositBankAccount,
      isSubmitNotificationActive: (state) =>
        state.components.submitNotification.isActive,
    }),
    ...mapState({
      selectedBankOnPicker: (state) => state.components.bankPicker.selectedBank,
    }),
    ...mapGetters('depositBankAccount', [
      'accountFamilyName',
      'accountFirstName',
      'canSubmitInput',
      'isVerifyResultExists',
      'verifyResultReasons',
      'verifyResultKeys',
    ]),
  },
  watch: {
    selectedBankOnPicker: function (val) {
      if (val) {
        this.selectBank(val)
        this.closeBankPicker()
      }
    },
  },
  methods: {
    ...mapActions('depositBankAccount', [
      'fetchDepositBankAccount',
      'selectBank',
      'inputDepositBankAccountAttr',
      'postDepositAccountBankUpdate',
    ]),
    ...mapActions('components/bankPicker', [
      'showBankPicker',
      'closeBankPicker',
    ]),
    ...mapMutations('depositBankAccount', ['updateDepositBankAccountAttr']),
    ...mapActions('components/submitNotification', {
      showSubmitNotification: 'show',
      onSubmitNotificationEntered: 'onEntered',
    }),
    onClickBankNameInput(e) {
      e.target.blur()
      this.showBankPicker()
    },
    input(e, name) {
      this.inputDepositBankAccountAttr({ name: name, value: e.target.value })
    },
    submit() {
      this.postDepositAccountBankUpdate()
        .then(this.showSubmitNotification)
        .catch(() => {})
    },
  },
  mounted() {
    this.fetchDepositBankAccount()
  },
}
</script>

<style scoped>
#bank__wrapper {
  position: relative;
  height: auto;
  min-height: 100%;
  background-color: #fafafa;
}
#bank__container {
  padding-top: 20px;
  padding-bottom: 49px;
}

#bank__container input {
  min-width: 144px;
}

#personal__submit {
  margin-top: 30px;
}

#bank__submit_button {
  width: 224px;
  height: 44px;
  display: table;
  margin: auto;
}
section {
  margin-bottom: 20px;
}
.bank__input_bank_name {
  width: 160px;
}
</style>
